import { stenaSailingRoundTrip } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const VehicleLengthFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { vehicleLength, setVehicleLength } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setVehicleLength({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return vehicleLength.from || vehicleLength.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"vehicleLength"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaSailingRoundTrip}
      children={
        <RangeControl<RangeFilter>
          value={vehicleLength}
          valueFrom={vehicleLength.from}
          valueTo={vehicleLength.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={maxNumbers}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
